import { Envelope } from "@phosphor-icons/react";

export default function EmailsTab({ emailLogs }) {
  return (
    <>
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-2">
          <Envelope size={16} weight="thin" className="text-[#D4AF37]" />
          <p className="text-xs text-[#A1A1AA] uppercase tracking-[0.15em] font-medium">Email Logs</p>
        </div>
        <p className="text-xs text-[#A1A1AA] font-light">
          Emails are currently <span className="text-[#D4AF37]">MOCKED</span> (logged to console). Add SendGrid API key to enable real delivery.
        </p>
      </div>
      {emailLogs.length === 0 ? (
        <p className="text-[#A1A1AA] text-sm font-light py-8">No emails sent yet. Order confirmation emails are triggered after successful payment.</p>
      ) : (
        <div className="space-y-3" data-testid="admin-email-logs">
          {emailLogs.map(log => (
            <div key={log.id} className="bg-[#121212] border border-[rgba(212,175,55,0.1)] p-5" data-testid={`email-log-${log.id}`}>
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-3">
                  <Envelope size={14} weight="thin" className="text-[#D4AF37]" />
                  <span className="text-xs text-[#FDFBF7] font-light">{log.subject}</span>
                </div>
                <EmailStatusBadge status={log.status} />
              </div>
              <p className="text-xs text-[#A1A1AA] font-light">To: {log.to}</p>
              <p className="text-xs text-[#A1A1AA] font-light mt-1">{log.body_preview}</p>
              <p className="text-[10px] text-zinc-600 mt-2">{new Date(log.created_at).toLocaleString()}</p>
            </div>
          ))}
        </div>
      )}
    </>
  );
}

function EmailStatusBadge({ status }) {
  if (status === "sent_mock") {
    return <span className="text-[10px] uppercase tracking-wider px-2 py-0.5 border border-yellow-500/30 text-yellow-400">Mocked</span>;
  }
  return <span className="text-[10px] uppercase tracking-wider px-2 py-0.5 border border-green-500/30 text-green-400">Sent</span>;
}
